import type { ReactNode } from "react";

export type HeroProps = {
  eyebrow?: ReactNode;
  title: ReactNode;
  body?: ReactNode;
  actions?: ReactNode;
  secondary?: ReactNode;
};

export function Hero({
  eyebrow,
  title,
  body,
  actions,
  secondary,
}: HeroProps) {
  return (
    <section
      className="relative overflow-hidden"
      style={{ backgroundColor: "#ffffff", color: "#0a0a0a" }}
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'url("/images/textures/grain-light.svg"), url("/images/textures/wildtextures-concrete-high-contrast.jpg")',
          backgroundSize: "200px 200px, 600px 600px",
          backgroundRepeat: "repeat",
          backgroundBlendMode: "multiply",
          opacity: 0.15,
          mixBlendMode: "multiply",
        }}
      />

      <div className="container-page relative z-10 py-16 sm:py-24 lg:py-32">
        <div className={secondary ? "grid gap-10 lg:grid-cols-2 lg:gap-16 items-center" : ""}>
          <div className="flex flex-col gap-6">
            {eyebrow ? (
              <span className="eyebrow">{eyebrow}</span>
            ) : null}

            <h1 className="font-display uppercase leading-[0.95] tracking-wide">
              {title}
            </h1>

            {body ? (
              <div className="text-lg max-w-prose leading-relaxed" style={{ color: "#0a0a0a" }}>
                {body}
              </div>
            ) : null}

            {actions ? (
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-2 w-full sm:w-auto">
                {actions}
              </div>
            ) : null}
          </div>

          {secondary ? (
            <div className="flex flex-col gap-5">{secondary}</div>
          ) : null}
        </div>
      </div>

      <div
        aria-hidden="true"
        className="absolute bottom-0 left-0 right-0"
        style={{ height: 3, backgroundColor: "#d71920" }}
      />
    </section>
  );
}
